export default __webpack_public_path__ + "static/media/zoom.d67951fd.png";